/**  @jsxImportSource @emotion/react */
import { useEffect } from "react";
import * as txt from "../../../../components/atoms/Typografy";
import { ForeignCurrencyTableRows, setHeightToTargetElement } from "./utils";

interface Props {
  triggerForeignCurrencyInsuranceRankAPI: boolean;
  setTriggerForeignCurrencyInsuranceRankAPI: (_: boolean) => void;
  isContentsColumnRendered: boolean;
  setIsContentsColumnRendered: (isContentsColumnRendered: boolean) => void;
}

export const HeadColumnForeignCurrency = ({
  triggerForeignCurrencyInsuranceRankAPI,
  setTriggerForeignCurrencyInsuranceRankAPI,
  isContentsColumnRendered,
  setIsContentsColumnRendered,
}: Props) => {
  
  useEffect(() => {
    if (isContentsColumnRendered) {
      ForeignCurrencyTableRows.map((selectorName) => {
        setHeightToTargetElement(selectorName);
        return null;
      });
      
      setIsContentsColumnRendered(false);
    }
  }, [
    isContentsColumnRendered,
    setIsContentsColumnRendered,
  ]);
  
  return (
    <>
      <div
        className="listHead h75"
        css={[txt.typographyAlignCenter]}
      >
        <span css={txt.typographyBlock}>資料</span>
      </div>
      <div
        id="attention"
        className="listHead mh50"
        css={[txt.typographyAlignCenter]}
      >
        <span css={txt.typographyBlock}>特徴</span>
      </div>
      <div
        id="condition"
        className="listHead mh50"
        css={[txt.typographyAlignCenter]}
      >
        <span css={txt.typographyBlock}>備考</span>
      </div>
      <div
        id="riskUrl"
        className="listHead mh50"
        css={[txt.typographyAlignCenter]}
      >
        <span css={txt.typographyBlock}>リスク確認URL</span>
      </div>
      <div
        id="approvalNumber"
        className="listHead mh100"
        css={[txt.typographyAlignCenter]}
      >
        <span css={txt.typographyBlock}>承認番号</span>
      </div>
    </>
  );
};
